module.exports = "data:text/x-markdown;base64,Q2FyZSBzaG91bGQgYmUgdGFrZW4gd2hlbiB1c2luZyBjb21wbGV4IGRhdGEgdHlwZXMgd2l0aGluIGZ1bmN0aW9ucy4gSW5jb3JyZWN0bHkgaW5pdGlhbGlzZWQgc3RvcmFnZSB2YXJpYWJsZXMgY2FuIGxlYWQgdG8gbW9kaWZpY2F0aW9uIG9mIG90aGVyIHN0b3JhZ2UgdmFyaWFibGVzIGFzIHRoaXMgbGV2ZWwgZGVtb25zdHJhdGVzLiAK"


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/locked_complete.md
// module id = 1390
// module chunks = 0